import apiClient from "./axiosConfig";
// 获取轮播图接口
export function getCarouselList() {
  return apiClient({
    url: "/interface/carouselimage/carouselimagelist",
    method: "get",
  });
}
